import { OptionType } from './type/option.type';
export class Option extends OptionType {}
